
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/spotify",
      function () {
        return require("private-next-pages/spotify.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/spotify"])
      });
    }
  